<script>
    export let val = 0;
    export let disabled = false;
    export let iconA = "";
    export let iconB = "";
    export let asImg = false;
</script>

<div class="root" style={disabled ? "opacity: .8;" : ""}>
    <div
        class={val === 0 ? "activeIcon activeIconInverse" : "activeIcon"}
        on:click={() => (val = 0)}
    >
        {#if asImg}
            <!-- svelte-ignore a11y-missing-attribute -->
            <!-- <img src={iconA} /> -->
            <span class="imgMask"></span>
        {:else}
            <span class="material-icons">
                {iconA}
            </span>
        {/if}
    </div>
    <div
        class={val === 1 ? "activeIcon activeIconInverse" : "activeIcon"}
        on:click={() => (val = 1)}
    >
        {#if asImg}
            <!-- svelte-ignore a11y-missing-attribute -->
            <!-- <img src={iconB} /> -->
            <span class="imgMask"></span>
        {:else}
            <span class="material-icons">
                {iconB}
            </span>
        {/if}
    </div>
    {#if disabled}
        <div class="disableOwerlay" />
    {/if}
</div>

<style>
    .activeIcon {
        margin: 0;
    }
    .root {
        margin: 0.5rem 0;
        display: flex;
        align-items: center;
        position: relative;
    }
    .disableOwerlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #00000060;
    }
</style>
